import type { InputHTMLAttributes } from 'react';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  label?: string;
  hint?: string;
  error?: string;
  value: string;
  mask: (raw: string) => string;
  onValueChange: (masked: string) => void;
}

export function MaskedInput({
  label,
  hint,
  error,
  value,
  mask,
  onValueChange,
  className = '',
  ...rest
}: Props) {
  return (
    <label className="block">
      {label && <span className="field-label">{label}</span>}
      <input
        {...rest}
        value={value}
        onChange={(e) => onValueChange(mask(e.target.value))}
        className={`field-input ${error ? 'border-red-400' : ''} ${className}`}
      />
      {hint && !error && <span className="block text-xs text-slate-500 mt-1">{hint}</span>}
      {error && <span className="block text-xs text-red-600 mt-1">{error}</span>}
    </label>
  );
}
